import * as React from "react";
import { useCallback } from "react";
import { CreateRouteAgreementModal } from "./CreateRouteAgreementModal";
import { useNavigate, useParams } from "react-router";

export interface Params {
  customerId: string;
  headAgreementId: string;
}

interface Props {}

export const CreateRouteAgreementRoute: React.FC<Props> = () => {
  const { customerId, headAgreementId } = useParams() as {
    customerId: string;
    headAgreementId: string;
  };
  const navigate = useNavigate();

  const onRequestClose = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  return (
    <CreateRouteAgreementModal
      customerId={customerId}
      headAgreementId={headAgreementId}
      isOpen
      onRequestClose={onRequestClose}
    />
  );
};
